module.exports = "img/photo34.42c032.jpg";